export class DialogModelAdnUpload{
    constructor(
      public data:any
    ) {}
  }